<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="S&eacute;rie&nbsp;C6100">
     S&eacute;rie&nbsp;C6100
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_fr" title="Consignes de s&eacute;curit&eacute;">
     Consignes de s&eacute;curit&eacute;
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href="safety.html#d0e23" title="Conventions">
      Conventions
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_fr" title="A propos de l'imprimante">
     A propos de l'imprimante
    </a>
   </p>
   <div id="divd0e187">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_fr" title="Recherche d'informations &agrave; propos de l'imprimante">
      Recherche d'informations &agrave; propos de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_fr" title="S&eacute;lection d'un emplacement pour l'imprimante">
      S&eacute;lection d'un emplacement pour l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-models-topic.html#configured-models_fr" title="Configurations de l'imprimante">
      Configurations de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_fr" title="Connexion des c&acirc;bles">
      Connexion des c&acirc;bles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_fr" title="A partir du panneau de commandes">
      A partir du panneau de commandes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-power-button-and-indicator-light-topic.html#understanding-status-power-button-and-indicator-light_fr" title="Comprendre l'&eacute;tat de la touche Marche/arr&ecirc;t et du voyant">
      Comprendre l'&eacute;tat de la touche Marche/arr&ecirc;t et du voyant
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_fr" title="Utilisation de l'&eacute;cran d'accueil">
      Utilisation de l'&eacute;cran d'accueil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-map-sfp-topic.html#menus-map-sfp_fr" title="Affichage des menus">
      Affichage des menus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_fr" title="Impression d'une page des param&egrave;tres des menus">
      Impression d'une page des param&egrave;tres des menus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_fr" title="Papier d&eacute;conseill&eacute;">
      Papier d&eacute;conseill&eacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_fr" title="Utilisation de papier recycl&eacute;">
      Utilisation de papier recycl&eacute;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_fr" title="Configuration et utilisation des applications pr&eacute;sentes sur l'&eacute;cran d'accueil">
     Configuration et utilisation des applications pr&eacute;sentes sur l'&eacute;cran d'accueil
    </a>
   </p>
   <div id="divd0e1161">
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_fr" title="Personnalisation de l'&eacute;cran d'accueil">
      Personnalisation de l'&eacute;cran d'accueil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_fr" title="Utilisation de la personnalisation de l'affichage">
      Utilisation de la personnalisation de l'affichage
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-forms-and-favorites-topic.html#setting-up-forms-and-favorites_fr" title="Configuration des formulaires et favoris">
      Configuration des formulaires et favoris
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_fr" title="Configuration des param&egrave;tres Eco">
      Configuration des param&egrave;tres Eco
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_fr" title="B&eacute;n&eacute;ficier de l'assistance client&egrave;le">
      B&eacute;n&eacute;ficier de l'assistance client&egrave;le
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_fr" title="Utilisation du G&eacute;n&eacute;rateur de code QR">
      Utilisation du G&eacute;n&eacute;rateur de code QR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_fr" title="Configuration de Quotas">
      Configuration de Quotas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-google-drive-topic.html#using-google-drive_fr" title="Utilisation de Google Drive">
      Utilisation de Google Drive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1390" title="G&eacute;rer les contacts">
      G&eacute;rer les contacts
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_fr" title="Configuration et utilisation des fonctions d'accessibilit&eacute;">
     Configuration et utilisation des fonctions d'accessibilit&eacute;
    </a>
   </p>
   <div id="divd0e1509">
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_fr" title="Activation du mode Agrandissement">
      Activation du mode Agrandissement
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_fr" title="Activation de l'assistance vocale">
      Activation de l'assistance vocale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_fr" title="R&eacute;glage du d&eacute;bit de parole de l'assistance vocale">
      R&eacute;glage du d&eacute;bit de parole de l'assistance vocale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_fr" title="Activation des codes PIN (num&eacute;ros d'identification personnels) ou des mots de passe &eacute;nonc&eacute;s">
      Activation des codes PIN (num&eacute;ros d'identification personnels) ou des mots de passe &eacute;nonc&eacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_fr" title="Navigation sur l'&eacute;cran &agrave; l'aide de gestes">
      Navigation sur l'&eacute;cran &agrave; l'aide de gestes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_fr" title="Utilisation du clavier &agrave; l'&eacute;cran">
      Utilisation du clavier &agrave; l'&eacute;cran
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_fr" title="Chargement du papier et des supports sp&eacute;ciaux">
     Chargement du papier et des supports sp&eacute;ciaux
    </a>
   </p>
   <div id="divd0e1712">
    <p class="toc-2-style">
     <a href="setting-paper-size-type-topic.html#setting-paper-size-type_fr" title="D&eacute;finition du format et du type des supports sp&eacute;ciaux">
      D&eacute;finition du format et du type des supports sp&eacute;ciaux
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_fr" title="Configuration des param&egrave;tres de papier Universel">
      Configuration des param&egrave;tres de papier Universel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_fr" title="Chargement des tiroirs">
      Chargement des tiroirs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_fr" title="Chargement du chargeur multifonction">
      Chargement du chargeur multifonction
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_fr" title="Tiroirs cha&icirc;n&eacute;s">
      Tiroirs cha&icirc;n&eacute;s
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_fr" title="Impression">
     Impression
    </a>
   </p>
   <div id="divd0e1899">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_fr" title="Impression depuis un ordinateur">
      Impression depuis un ordinateur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-forms-topic.html#printing-forms_fr" title="Impression de formulaires">
      Impression de formulaires
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1951" title="Impression &agrave; partir d'un appareil mobile">
      Impression &agrave; partir d'un appareil mobile
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-h2-topic.html#printing-from-flash-drive-h2_fr" title="Impression &agrave; partir d'un lecteur flash">
      Impression &agrave; partir d'un lecteur flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_fr" title="Lecteurs flash et types de fichiers pris en charge">
      Lecteurs flash et types de fichiers pris en charge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_fr" title="Configuration des travaux confidentiels">
      Configuration des travaux confidentiels
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-h-topic.html#printing-confidential-and-other-held-jobs-h_fr" title="Impression des t&acirc;ches suspendues">
      Impression des t&acirc;ches suspendues
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_fr" title="Impression de la liste des &eacute;chantillons de polices">
      Impression de la liste des &eacute;chantillons de polices
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_fr" title="Annulation d'une t&acirc;che d'impression">
      Annulation d'une t&acirc;che d'impression
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_fr" title="S&eacute;curisation de l'imprimante">
     S&eacute;curisation de l'imprimante
    </a>
   </p>
   <div id="divd0e2343">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_fr" title="Emplacement du logement de s&eacute;curit&eacute;">
      Emplacement du logement de s&eacute;curit&eacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_fr" title="Effacement de la m&eacute;moire de l'imprimante">
      Effacement de la m&eacute;moire de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_fr" title="Effacement de la m&eacute;moire du disque dur de l'imprimante">
      Effacement de la m&eacute;moire du disque dur de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-hard-disk-encryption-topic.html#configuring-printer-hard-disk-encryption_fr" title="Configuration du chiffrement du disque dur de l'imprimante">
      Configuration du chiffrement du disque dur de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_fr" title="Restauration des param&egrave;tres usine">
      Restauration des param&egrave;tres usine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_fr" title="D&eacute;claration relative &agrave; la volatilit&eacute;">
      D&eacute;claration relative &agrave; la volatilit&eacute;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_fr" title="Maintenance de l'imprimante">
     Maintenance de l'imprimante
    </a>
   </p>
   <div id="divd0e2553">
    <p class="toc-2-style">
     <a href="adjusting-default-internal-speaker-volume-topic.html#d0e2558" title="R&eacute;glage du volume du haut-parleur">
      R&eacute;glage du volume du haut-parleur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-using-printer-control-panel-topic.html#d0e2650" title="Utilisation en r&eacute;seau">
      Utilisation en r&eacute;seau
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_fr" title="Configuration de l'impression s&eacute;rie (Windows uniquement)">
      Configuration de l'impression s&eacute;rie (Windows uniquement)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_fr" title="Nettoyage de l'imprimante">
      Nettoyage de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_fr" title="Commande de pi&egrave;ces et de fournitures">
      Commande de pi&egrave;ces et de fournitures
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-developer-unit-topic.html#d0e3215" title="Remplacement des pi&egrave;ces et fournitures">
      Remplacement des pi&egrave;ces et fournitures
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-supplies-topic.html#storing-supplies_fr" title="Stockage des fournitures">
      Stockage des fournitures
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e3685" title="D&eacute;placement de l'imprimante">
      D&eacute;placement de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e3742" title="Economie d'&eacute;nergie et de papier">
      Economie d'&eacute;nergie et de papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e3881" title="Recyclage">
      Recyclage
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_fr" title="Elimination des bourrages">
     Elimination des bourrages
    </a>
   </p>
   <div id="divd0e3935">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_fr" title="R&eacute;duction des risques de bourrage">
      R&eacute;duction des risques de bourrage
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_fr" title="Identification des zones de bourrage">
      Identification des zones de bourrage
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-trays-topic.html#jam-in-trays_fr" title="Bourrage papier dans les tiroirs">
      Bourrage papier dans les tiroirs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jams-in-mpf-topic.html#jams-in-mpf_fr" title="Bourrage papier dans le chargeur multifonction">
      Bourrage papier dans le chargeur multifonction
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-standard-bin-topic.html#jam-in-standard-bin_fr" title="Bourrage papier dans le r&eacute;ceptacle standard">
      Bourrage papier dans le r&eacute;ceptacle standard
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-door-b-topic.html#jam-in-door-b_fr" title="Bourrage papier derri&egrave;re la porte&nbsp;B">
      Bourrage papier derri&egrave;re la porte&nbsp;B
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-finisher-bin-topic.html#jam-in-finisher-bin_fr" title="Bourrage papier dans le bac de l'unit&eacute; de finition">
      Bourrage papier dans le bac de l'unit&eacute; de finition
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-door-g-topic.html#staple-jam-door-g_fr" title="Bourrage d'agrafes derri&egrave;re la porte G">
      Bourrage d'agrafes derri&egrave;re la porte G
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_fr" title="D&eacute;pannage">
     D&eacute;pannage
    </a>
   </p>
   <div id="divd0e4279">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e4282" title="Probl&egrave;mes de connexion r&eacute;seau">
      Probl&egrave;mes de connexion r&eacute;seau
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e4497" title="Probl&egrave;mes li&eacute;s aux options mat&eacute;rielles">
      Probl&egrave;mes li&eacute;s aux options mat&eacute;rielles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e4770" title="Probl&egrave;mes li&eacute;s aux fournitures">
      Probl&egrave;mes li&eacute;s aux fournitures
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_fr" title="Probl&egrave;mes de chargement du papier">
      Probl&egrave;mes de chargement du papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_fr" title="Probl&egrave;mes d'impression">
      Probl&egrave;mes d'impression
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#d0e7322" title="Probl&egrave;mes de qualit&eacute; des couleurs">
      Probl&egrave;mes de qualit&eacute; des couleurs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_fr" title="Contacter l'assistance client&egrave;le">
      Contacter l'assistance client&egrave;le
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_fr" title="Mise &agrave; niveau et migration">
     Mise &agrave; niveau et migration
    </a>
   </p>
   <div id="divd0e7558">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e7561" title="Mat&eacute;riel">
      Mat&eacute;riel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7889" title="Logiciel">
      Logiciel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e7966" title="Microcode">
      Microcode
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_fr" title="Avis">
     Avis
    </a>
   </p>
   <div id="divd0e8036">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8039" title="Informations produit">
      Informations produit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8056" title="Note d'&eacute;dition">
      Note d'&eacute;dition
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_fr" title="Marques commerciales">
      Marques commerciales
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_fr" title="Avis relatifs &agrave; l'accord de licence">
      Avis relatifs &agrave; l'accord de licence
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_fr" title="Niveaux d'&eacute;mission sonore">
      Niveaux d'&eacute;mission sonore
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8144" title="Guide de Tri pour la France">
      Guide de Tri pour la France
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8157" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8184" title="Batterie rechargeable au lithium-ion">
      Batterie rechargeable au lithium-ion
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_fr" title="R&egrave;glement (UE) 2023/1542">
      R&egrave;glement (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_fr" title="Retour des cartouches Lexmark pour r&eacute;utilisation ou recyclage">
      Retour des cartouches Lexmark pour r&eacute;utilisation ou recyclage
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_fr" title="Avis relatif &agrave; l'&eacute;lectricit&eacute; statique">
      Avis relatif &agrave; l'&eacute;lectricit&eacute; statique
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_fr" title="Informations de temp&eacute;rature">
      Informations de temp&eacute;rature
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_fr" title="Avis relatif &agrave; l'utilisation du laser">
      Avis relatif &agrave; l'utilisation du laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-advisory-label_fr" title="Etiquette d'avis relatif &agrave; l'utilisation de laser">
      Etiquette d'avis relatif &agrave; l'utilisation de laser
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue